module.exports = __webpack_public_path__ + "img/RU.e3083c23.svg";